$(document).ready(
    function () {

        let p = $("body").attr("p");

        if (p === 'organizer_settings') {

            $(".organizer-translations-organizer-about-button").on("click", function (e) {
                e.preventDefault();
                let language = $(this).attr('data-language');

                if ($(".organizer-translations-organizer-about-wrapper[data-language='" + language +"']").hasClass('d-none')){
                    $(".organizer-translations-organizer-about-wrapper[data-language='" + language +"']").removeClass('d-none');
                }

            });

        }


        if (p === 'organizer_event') {

            $(".organizer-translations-event-name-button").on("click", function (e) {
                e.preventDefault();
                let language = $(this).attr('data-language');

                if ($(".organizer-translations-event-name-wrapper[data-language='" + language +"']").hasClass('d-none')){
                    $(".organizer-translations-event-name-wrapper[data-language='" + language +"']").removeClass('d-none');
                }

            });

            $(".organizer-translations-event-description-button").on("click", function (e) {
                e.preventDefault();
                let language = $(this).attr('data-language');

                if ($(".organizer-translations-event-description-wrapper[data-language='" + language +"']").hasClass('d-none')){
                    $(".organizer-translations-event-description-wrapper[data-language='" + language +"']").removeClass('d-none');
                }

            });
        }

        if (p === 'organizer_event_ticket_category') {

            $(".organizer-translations-event-ticket-category-name-button").on("click", function (e) {
                e.preventDefault();
                let language = $(this).attr('data-language');

                if ($(".organizer-translations-event-ticket-category-name-wrapper[data-language='" + language +"']").hasClass('d-none')){
                    $(".organizer-translations-event-ticket-category-name-wrapper[data-language='" + language +"']").removeClass('d-none');
                }

            });

            $(".organizer-translations-event-ticket-category-description-button").on("click", function (e) {
                e.preventDefault();
                let language = $(this).attr('data-language');

                if ($(".organizer-translations-event-ticket-category-description-wrapper[data-language='" + language +"']").hasClass('d-none')){
                    $(".organizer-translations-event-ticket-category-description-wrapper[data-language='" + language +"']").removeClass('d-none');
                }

            });

            $(".organizer-translations-event-ticket-category-order-notification-button").on("click", function (e) {
                e.preventDefault();
                let language = $(this).attr('data-language');

                if ($(".organizer-translations-event-ticket-category-order-notification-wrapper[data-language='" + language +"']").hasClass('d-none')){
                    $(".organizer-translations-event-ticket-category-order-notification-wrapper[data-language='" + language +"']").removeClass('d-none');
                }

            });
        }

        if (p === 'organizer_event_form') {

            $(document).on("click", ".organizer-translations-event-form-label-button", function (e) {
                e.preventDefault();
                let language = $(this).attr('data-language');
                let eventFormIndex = $(this).attr('data-event-form-index');

                if ($(".organizer-translations-event-form-label-wrapper[data-language='" + language +"'][data-event-form-index='" + eventFormIndex + "']").hasClass('d-none')){
                    $(".organizer-translations-event-form-label-wrapper[data-language='" + language +"'][data-event-form-index='" + eventFormIndex + "']").removeClass('d-none');
                }

            });

            $(document).on("click", ".organizer-translations-event-form-answer-option-button", function (e) {
                e.preventDefault();
                let language = $(this).attr('data-language');
                let eventFormIndex = $(this).attr('data-event-form-index');
                let eventFormAnswerOptionIndex = $(this).attr('data-event-form-answer-option-index');

                if ($(".organizer-translations-event-form-answer-option-wrapper[data-language='" + language +"'][data-event-form-index='" + eventFormIndex + "'][data-event-form-answer-option-index='" + eventFormAnswerOptionIndex + "']").hasClass('d-none')){
                    $(".organizer-translations-event-form-answer-option-wrapper[data-language='" + language +"'][data-event-form-index='" + eventFormIndex + "'][data-event-form-answer-option-index='" + eventFormAnswerOptionIndex + "']").removeClass('d-none');
                }

            });
        }
    }
    );